/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChevronsUpDown = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m7 15 5 5 5-5" }],
    ["path", { d: "m7 9 5-5 5 5" }]
  ]
];

export { ChevronsUpDown as default };
//# sourceMappingURL=chevrons-up-down.js.map
